import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Moon, SunMedium, LogOut, UserRound, Menu } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { ROLE_LABELS } from '../../lib/format';

const TITLES = [
  ['/cotizaciones-pv', 'Cotizaciones eHenergia / Prefab PV'],
  ['/cotizaciones', 'Cotizaciones Prefab'],
  ['/contenedores', 'Contenedores'],
  ['/clientes', 'Clientes'],
  ['/proyectos', 'Proyectos'],
  ['/catalogo-pv', 'Catálogo PV'],
  ['/catalogo-contenedores', 'Catálogo Contenedores'],
  ['/catalogo', 'Catálogo Prefab'],
  ['/usuarios', 'Usuarios'],
];

export const Topbar = () => {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const title = TITLES.find(([p]) => pathname.startsWith(p))?.[1] || 'Dashboard';

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-20 h-14 flex items-center justify-between px-5 border-b border-border bg-background/70 backdrop-blur supports-[backdrop-filter]:bg-background/55"
    >
      <div className="flex items-center gap-3">
        <h1 className="text-[15px] font-semibold" data-testid="topbar-title">{title}</h1>
      </div>
      <div className="flex items-center gap-1.5">
        <Button
          variant="ghost"
          size="icon"
          onClick={toggle}
          data-testid="theme-toggle-button"
          title={theme === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
          className="text-muted-foreground hover:text-foreground"
        >
          {theme === 'dark' ? <SunMedium size={18} /> : <Moon size={18} />}
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="gap-2 pl-2 pr-3" data-testid="user-menu-trigger">
              <div className="h-7 w-7 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center">
                <UserRound size={15} className="text-primary" />
              </div>
              <div className="text-left leading-tight hidden sm:block">
                <div className="text-[13px] font-medium">{user?.name}</div>
                <div className="text-[10px] text-muted-foreground">{ROLE_LABELS[user?.role] || user?.role}</div>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-52">
            <DropdownMenuLabel className="text-xs text-muted-foreground">{user?.email}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout} data-testid="logout-button" className="text-destructive focus:text-destructive">
              <LogOut size={15} className="mr-2" /> Cerrar sesión
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};
